import styled from "styled-components"
import * as designConstants from "app/static/frontend/design-constants"

export const PermissionsWrapper = styled.div`
    display: flex;
    flex-direction: column;

    & > :not(:last-child) {
        margin-bottom: 24px;
    }
`

export const Description = styled.span`
    font-size: 16px;

    a,
    a:visited,
    a:link {
        color: ${designConstants.QuorumBlue};
        text-decoration: 1px underline ${designConstants.QuorumBlue};
    }
`
